.container {
  overflow: hidden;
  min-width: 30%;
  display: flex;
  flex: 1;
  flex-direction: column;
}

.feedItemContent {
  flex: 1;
}

.resolveButton {
  color: transparent;
}

.resolvedFeed {
  overflow: auto;
}
